import type { SocialNetworksBlockProps } from "./types";
import PanelContainer from "../../lib/panel/panel-container";
import PanelBlockAlignment from "../../lib/panel/panel-block-alignment";
import PanelTranslationState from "../../lib/panel/panel-translation-state";


export function SocialNetworksEmailPanelRenderer(blockProps: SocialNetworksBlockProps) {

	return (
		<PanelContainer blockProps={blockProps}>
			<PanelBlockAlignment />
      <PanelTranslationState mode="not-translatable" portal />
    </PanelContainer>
	);
}
